export const buildDocumentTitle = ({
  metaTitle,
  pageTitle,
  tabTitle,
  siteTitle,
}: {
  metaTitle?: string | null
  pageTitle?: string
  tabTitle?: string
  siteTitle: string
}): string => {
  const trimmedMetaTitle = metaTitle?.trim()
  if (trimmedMetaTitle) {
    return [trimmedMetaTitle, siteTitle].filter(Boolean).join(' | ')
  }

  const segments = [tabTitle, pageTitle, siteTitle].filter(
    (segment): segment is string => Boolean(segment),
  )
  return segments.join(' | ')
}
